import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_OLD } from '../data/religione';
const recap = ['9 volumi', '5 bonus', 'oltre 500 pagine', 'Secondaria e Primaria'];
const reassurances = ['Download digitale immediato', 'PDF stampabili', 'Garanzia di 7 giorni'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="15fggqhcwiwzc">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1jb22mfnu90nj" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1t2yaujjn275h">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t252xf8y1blr">
          Entra in aula con <em className="text-red-700" data-id="element-116" data-mp="223mgapuyuz6r">tutto pronto.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="223w7uhvnteek">
          Invece di cercare schede, creare ogni attività da solo e passare le domeniche sera a
          programmare, hai un sistema di Arte e Immagine organizzato per tutto l'anno scolastico. Più tempo per
          quello che conta davvero:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="x41w81uir79s">
          I tuoi alunni. Le tue lezioni. La tua vita fuori dalla scuola.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="120ion88r47so">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="1b2rtpil938yo">{item}</li>)}
        </ul>

        <p className="mt-8 text-sm text-slate-900/60" data-id="element-121" data-mp="1b1gr3m3jk795">invece di <s data-id="element-122" data-mp="1fvb7ognuo640">{PRICE_OLD}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fv1s7n0flhck">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1kvfu0nbfvv25">Pagamento unico – nessun abbonamento.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1pqcz5j5llk9r">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1tt9i5az1vie8" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="3quowstf7croc">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3lwdnqkwqel76">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3hl4t588aabk" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}